import { z } from 'zod';

export const ClaimGlazierInvoiceFormSchema = z
  .object({
    invoice: z.array(z.unknown()),
  })
  .superRefine((data, ctx) => {
    if (data.invoice.length < 1) {
      ctx.addIssue({
        path: ['invoice'],
        message: 'Invoice is required',
        code: 'custom',
      });
    }
  });

export const PartiallyCompleteJobFormSchema = z
  .object({
    note: z.string(),
  })
  .superRefine((data, ctx) => {
    if (!data.note?.trim()) {
      ctx.addIssue({
        path: ['note'],
        message: 'Note is required',
        code: 'custom',
      });
    }
  });
